import React from 'react';
import {CircularProgress, FormControl, FormHelperText, InputAdornment, InputLabel, MenuItem, Select} from '@mui/material';

/**
 * PatrimoineSelector — sélection d'un patrimoine dans la liste d'un client. Composant d'affichage : pendant le chargement, le
 * champ est désactivé avec un indicateur inline et `message` dit ce qui se passe (jamais une liste vide silencieuse).
 *
 * Props : patrimoines ([{id, libelle}]), value (id | null), onChange (id), loading, disabled, message (texte sous le champ), error.
 */
export default function PatrimoineSelector({patrimoines = [], value = null, onChange, loading = false, disabled = false, message = null, error = false, sx}) {
    return (
        <FormControl size="small" sx={sx} disabled={disabled || loading} error={error}>
            <InputLabel id="patrimoine-selector-label">Patrimoine</InputLabel>
            <Select labelId="patrimoine-selector-label" label="Patrimoine" value={value == null ? '' : String(value)}
                    onChange={(e) => onChange(e.target.value)}
                    endAdornment={loading
                        ? <InputAdornment position="end" sx={{mr: 2}}><CircularProgress size={18} aria-label="Chargement des patrimoines"/></InputAdornment>
                        : null}>
                {patrimoines.map((p) => <MenuItem key={p.id} value={String(p.id)}>{p.libelle}</MenuItem>)}
            </Select>
            {message && <FormHelperText>{message}</FormHelperText>}
        </FormControl>
    );
}
